import { createSlice } from "@reduxjs/toolkit";

const employeeSlice = createSlice({
  name: "employee",
  initialState: {
    loading: false,
    error: null,
    employees: [],
    totalCount: {},
    employeeProfileUiid: null,
    currentEmployee: {
      employeeDetails: {},
      loadedTabs: [],
    }, // Add this for single employee data

    //Add Employee Save in Draft
    draft: null,
    lastSaved: null,
    addNewEmployee: {
      loading: false,
      success: false,
      error: null,
    },
    placementUiid: null,
    empOtherPayemntsSelectTimeSheets:[],
    empRecieveSelectDeductions:[]
  },
  reducers: {
    getEmployeesStart(state, action) {
      const { limit, page, employmentType, ret } = action.payload;

      state.loading = true;
    },
    getEmployeesSuccess(state, action) {
      state.loading = false;
      //state.employees = action.payload;
      state.employees = action.payload.data; // Store paginated data
      state.totalCount = action.payload.totalCount; // Store total count
    },
    getEmployeesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    setEmployeeProfileUiid(state, action) {
      //console.log("action.payload", action.payload);
      const { uiid } = action.payload;
      if (state.employeeProfileUiid !== uiid) {
        state.currentEmployee = {
          employeeDetails: {},
          loadedTabs: [],
        };
      }
      state.employeeProfileUiid = action.payload;
    },
    /////

    getEmployeeByUiidStart(state, action) {
      const { uiid } = action.payload;
      // console.log("uiid", uiid);
      // console.log("state.employeeProfileUiid", state.employeeProfileUiid);
      // Only reset if employee ID changes
      if (state.employeeProfileUiid !== uiid) {
        //console.log("not matching");
        state.currentEmployee = {
          employeeDetails: {},
          loadedTabs: [],
        };
      }
      //console.log("below data");
      state.loading = true;
      state.error = null;
    },

    getEmployeeByUiidSuccess(state, action) {
      const { data, tab } = action.payload;
      state.loading = false;
      // console.log("data", data);
      const newData = data.data || {};
      state.currentEmployee = {
        ...state.currentEmployee,
        employeeDetails: {
          ...state.currentEmployee.employeeDetails,
          ...newData,
        },
        loadedTabs: [...new Set([...state.currentEmployee.loadedTabs, tab])],
      };
    },
    // getEmployeeByUiidSuccess(state, action) {
    //   const { data, tab } = action.payload;
    //   // Mark loading as false
    //   state.loading = false;
    //   const newData = data.data || {};
    //   // Check if the uiid in the new data matches the current one in employeeDetails
    //   if (
    //     String(state.currentEmployee.employeeDetails._id) ===
    //     String(newData._id)
    //   ) {
    //     // If the uiid matches, update the employeeDetails with the new data
    //     state.currentEmployee = {
    //       ...state.currentEmployee,
    //       employeeDetails: {
    //         ...state.currentEmployee.employeeDetails,
    //         ...newData, // Merge new data into the existing details
    //       },
    //       // Handle loadedTabs: add the new tab if it's not already there
    //       loadedTabs: state.currentEmployee.loadedTabs.includes(tab)
    //         ? state.currentEmployee.loadedTabs // Don't modify if already exists
    //         : [...state.currentEmployee.loadedTabs, tab], // Add new tab
    //     };
    //   } else {
    //     state.currentEmployee = {
    //       ...state.currentEmployee,
    //       employeeDetails: {
    //         ...newData,
    //       },
    //       loadedTabs: [tab], // Start fresh with the new tab
    //     };
    //   }
    // },

    getEmployeeByUiidFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    // Add Employee Save in Draft
    saveDraft: (state, action) => {
      state.draft = action.payload;
      state.lastSaved = new Date().toISOString();
    },
    clearDraft: (state) => {
      state.draft = null;
      state.lastSaved = null;
    },

    // Add Employee
    addNewEmployeeStart(state) {
      state.loading = true;
      state.error = null;
    },

    addNewEmployeeSuccess(state) {
      state.loading = false;
      state.draft = null;
      state.lastSaved = null;
    },

    addNewEmployeeFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    // update Employee slice
    updateEmployeeStart(state) {
      state.loading = true;
      state.error = null;
    },

    updateEmployeeSuccess(state) {
      state.loading = false;
      state.draft = null;
      state.lastSaved = null;
    },

    updateEmployeeFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    bulkUpdateEmployeeStart(state) {
      state.loading = true;
      state.error = null;
    },

    bulkUpdateEmployeeSuccess(state) {
      state.loading = false;
      state.draft = null;
      state.lastSaved = null;
    },

    bulkUpdateEmployeeFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    clearEmployeeData(state) {
      state.currentEmployee = {
        employeeDetails: {},
        loadedTabs: [],
      };
      state.employeeProfileUiid = null;
      state.draft = null;
      state.lastSaved = null;
      state.loading = false;
      state.error = null;
    },
    empOtherPayementsTimeSheet(state,action){
      state.empOtherPayemntsSelectTimeSheets=action.payload
    },
    empRecieveSelectDeductionsStart(state,action){
      state.empRecieveSelectDeductions=action.payload
    }
  },
});

export const {
  getEmployeesStart,
  getEmployeesSuccess,
  getEmployeesFailure,
  setEmployeeProfileUiid,
  // Add these new actions
  getEmployeeByUiidStart,
  getEmployeeByUiidSuccess,
  getEmployeeByUiidFailure,
  // Add Employee Save in Draft
  saveDraft,
  clearDraft,
  // Add New Employee
  addNewEmployeeStart,
  addNewEmployeeSuccess,
  addNewEmployeeFailure,
  // Update Employee
  updateEmployeeStart,
  updateEmployeeSuccess,
  updateEmployeeFailure,
  bulkUpdateEmployeeStart,
  bulkUpdateEmployeeSuccess,
  bulkUpdateEmployeeFailure,
  clearEmployeeData,
  empOtherPayementsTimeSheet,
  empRecieveSelectDeductionsStart
} = employeeSlice.actions;
export default employeeSlice.reducer;
